import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { BehaviorSubject, Observable } from 'rxjs';

const STORAGE_KEY = 'HubbubHR_AccessibilityMode';

@Injectable({
  providedIn: 'root'
})
export class AccessibilityService {

  private _enabled$ = new BehaviorSubject<boolean>(false);

  get enabled$(): Observable<boolean> {
    return this._enabled$.asObservable();
  }

  get isEnabled(): boolean {
    return this._enabled$.getValue();
  }

  constructor(@Inject(DOCUMENT) private document: Document) {}

  /** Call once on app startup to restore the saved preference. */
  init(): void {
    const saved = localStorage.getItem(STORAGE_KEY);
    const enabled = saved === 'true';
    this._apply(enabled);
  }

  toggle(): void {
    this._apply(!this._enabled$.getValue());
  }

  private _apply(enabled: boolean): void {
    const body = this.document.body;
    if (enabled) {
      body.classList.add('accessibility-mode');
    } else {
      body.classList.remove('accessibility-mode');
    }
    localStorage.setItem(STORAGE_KEY, String(enabled));
    this._enabled$.next(enabled);
  }
}
